module.exports = __webpack_public_path__ + "static/GiftBox_zpsogx0dkjz-5329e6919fd5c75287b4d5880fd38256.jpg";